import React from 'react';
import './LoadingModal.css';

type ModalState = 'loading' | 'success' | 'error';

interface LoadingModalProps {
  isOpen: boolean;
  title: string;
  message: string;
  state?: ModalState;
  sugestoes?: string[];
  extraActions?: React.ReactNode;
  onClose?: () => void;
}

const LoadingModal: React.FC<LoadingModalProps> = ({
  isOpen,
  title,
  message,
  state = 'loading',
  sugestoes = [],
  extraActions,
  onClose
}) => {
  if (!isOpen) return null;

  const renderAnimation = () => {
    switch (state) {
      case 'success':
        return (
          <div className="success-animation-container">
            <div className="success-checkmark">
              <i className="fas fa-check-circle"></i>
            </div>
          </div>
        );
      case 'error':
        return (
          <div className="error-animation-container">
            <div className="error-icon">
              <i className="fas fa-exclamation-triangle"></i>
            </div>
          </div>
        );
      default:
        return (
          <div className="loading-animation-container">
            {/* Ícones educacionais animados */}
            <div className="floating-icons">
              <i className="fas fa-book floating-icon icon-1"></i>
              <i className="fas fa-pencil-alt floating-icon icon-2"></i>
              <i className="fas fa-graduation-cap floating-icon icon-3"></i>
              <i className="fas fa-chalkboard-teacher floating-icon icon-4"></i>
              <i className="fas fa-apple-alt floating-icon icon-5"></i>
              <i className="fas fa-calculator floating-icon icon-6"></i>
            </div>
            
            {/* Spinner central */}
            <div className="central-spinner">
              <i className="fas fa-cog fa-spin"></i>
            </div>
          </div>
        );
    }
  };

  const getHeaderClass = () => {
    switch (state) {
      case 'success':
        return 'loading-modal-header success-header';
      case 'error':
        return 'loading-modal-header error-header';
      default:
        return 'loading-modal-header';
    }
  };

  return (
    <div className="loading-modal-overlay">
      <div className="loading-modal">
        <div className={getHeaderClass()}>
          <h4 className="loading-modal-title">{title}</h4>
          {(state === 'success' || state === 'error') && onClose && (
            <button 
              type="button" 
              className="btn-close btn-close-white" 
              onClick={onClose}
            ></button>
          )}
        </div>
        
        <div className="loading-modal-body">
          {renderAnimation()}
          
          <div className="loading-message">
            <p className="mb-2">{message}</p>
            {state === 'loading' && (
              <div className="progress-dots">
                <span className="dot dot-1"></span>
                <span className="dot dot-2"></span>
                <span className="dot dot-3"></span>
              </div>
            )}
            {state === 'success' && sugestoes.length > 0 && (
              <div className="alert alert-warning text-start mt-3 mb-0">
                <strong>Sugestões para uma grade perfeita:</strong>
                <ul className="mb-0 mt-2">
                  {sugestoes.map((sugestao, index) => (
                    <li key={index}>{sugestao}</li>
                  ))}
                </ul>
              </div>
            )}
            {(state === 'success' || state === 'error') && (
              <div className="mt-3 d-flex gap-2 justify-content-center">
                {extraActions}
                {onClose && (
                  <button
                    type="button"
                    className={`btn ${state === 'success' ? 'btn-success' : 'btn-danger'}`}
                    onClick={onClose}
                  >
                    <i className="fas fa-times me-2"></i>
                    Fechar
                  </button>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoadingModal;